module.exports = ["binance","bitfinex","bitstamp","bittrex","bitz","cryptopia","gemini","cobinhood","gdax","kucoin","lbank","liqui","okex","hadax","huobipro","hitbtc","poloniex","kraken","wex"]


//////////////////
// WEBPACK FOOTER
// ./src/data/mendExchanges.json
// module id = 653
// module chunks = 0